import api from './api';

// Tiny shared server-state cache for read-only Ai-Vis resources. It deduplicates
// concurrent GETs across routes without adding a second state-management library.
const cache = new Map();
const inFlight = new Map();

export async function cachedGet(key, url, { maxAge = 15000, signal } = {}) {
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && now - cached.at < maxAge) return cached.data;

  let pending = inFlight.get(key);
  if (!pending) {
    pending = api.get(url, { signal }).then((response) => {
      cache.set(key, { at: Date.now(), data: response.data });
      return response.data;
    }).finally(() => {
      inFlight.delete(key);
    });
    inFlight.set(key, pending);
  }
  return pending;
}

export function invalidateCachedGet(prefix) {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key);
  }
}
